import { z } from "zod";
import { optionalUuid } from "../lib/zod-helpers";
import { paginationSchema } from "./pagination";

/**
 * HCA Moravia — dotační modul (Sprint 55, §12).
 */

export const dotaceStavSchema = z.enum([
  "priprava",
  "podano",
  "schvaleno",
  "probiha",
  "dokonceno",
  "zamitnuto",
  "vraceno",
]);
export type DotaceStav = z.infer<typeof dotaceStavSchema>;

const uuidMsg = "Neplatné UUID";
const kcField = z.coerce.number().nonnegative().max(1_000_000_000);

export const createDotaceProjektSchema = z.object({
  nazev: z.string().min(1).max(255),
  poskytovatel: z.string().min(1).max(200),
  referenceNumber: z.string().max(100).optional(),
  castkaDotace: kcField,
  castkaVlastni: kcField.default(0),
  stav: dotaceStavSchema.default("priprava"),
  datumPodani: z.coerce.date().optional(),
  datumSchvaleni: z.coerce.date().optional(),
  datumZahajeni: z.coerce.date().optional(),
  datumUkonceni: z.coerce.date().optional(),
  pocetUcastniku: z.coerce.number().int().min(0).default(0),
  minPocetZamestnancu: z.coerce.number().int().min(0).optional(),
  firmaId: optionalUuid(uuidMsg),
  popis: z.string().max(10000).optional(),
});

export const updateDotaceProjektSchema = createDotaceProjektSchema.partial().extend({
  id: z.string().uuid(uuidMsg),
});

export const moveDotaceStavSchema = z.object({
  id: z.string().uuid(uuidMsg),
  stav: dotaceStavSchema,
});

export const dotaceProjektIdSchema = z.object({ id: z.string().uuid(uuidMsg) });

export const listDotaceProjektySchema = paginationSchema.extend({
  stav: dotaceStavSchema.optional(),
  poskytovatel: z.string().max(200).optional(),
});

export const addDotaceMilestoneSchema = z.object({
  projektId: z.string().uuid(uuidMsg),
  nazev: z.string().min(1).max(200),
  typ: z.enum(["report", "platba", "jina"]),
  dueDate: z.coerce.date(),
  poznamka: z.string().max(2000).optional(),
});

export const completeDotaceMilestoneSchema = z.object({
  id: z.string().uuid(uuidMsg),
});

export const linkDotaceTerminSchema = z.object({
  projektId: z.string().uuid(uuidMsg),
  terminId: z.string().uuid(uuidMsg),
  pocetUcastnikuZapocitano: z.coerce.number().int().min(0).default(0),
});

export const getUpcomingMilestonesSchema = z.object({
  daysAhead: z.coerce.number().int().min(1).max(90).default(14),
});
